import React, { useContext, useState } from 'react';
import { AutomationEditor } from './AutomationEditor';
import { SettingsControl } from './settings-controls';
import { AutomationEditorContext } from './AutomationEditorContext';
import { useUpdateAutomationTemplate } from '../useAutomationTemplates';
import { ReorderWarningDialog } from './ReorderWarningDialog';
import styles from './EditAutomationTemplate.module.css';

const { headerContent, syncButton, reorderNotification } = styles;

export const EditAutomationTemplateContent: React.FC = () => {
  const { editor } = useContext(AutomationEditorContext)!;
  const { state, markClean, template, undoReorder } = editor;
  const updateMutation = useUpdateAutomationTemplate();
  const [showReorderWarning, setShowReorderWarning] = useState(false);

  const { localContents, hasReorderedOrAdded, hasStepsNeedingSetup, isDirty } =
    state;
  const { description, name } = localContents;

  const handleSave = () => {
    updateMutation.mutate(
      { id: template.id, params: { contents: localContents } },
      { onSuccess: () => markClean() },
    );
  };

  const handleSaveClick = hasReorderedOrAdded
    ? setShowReorderWarning.bind(null, true)
    : handleSave;
  return (
    <>
      <header className={headerContent}>
        <hgroup>
          <h1>{name}</h1>
          <p>{description}</p>
          {hasReorderedOrAdded && (
            <div className={reorderNotification}>
              <span>
                Automation steps have been added, deleted or re-ordered.
              </span>
              <button
                type="button"
                onClick={undoReorder}
                aria-label="Undo reorder">
                Undo?
              </button>
            </div>
          )}
        </hgroup>
        <aside>
          <SettingsControl />
          <button
            className={syncButton}
            type="button"
            onClick={handleSaveClick}
            disabled={
              !isDirty || hasStepsNeedingSetup || updateMutation.isPending
            }
            title={
              hasStepsNeedingSetup
                ? 'Please configure all steps before saving'
                : undefined
            }>
            {updateMutation.isPending ? 'Saving...' : 'Save'}
          </button>
        </aside>
      </header>
      <AutomationEditor />
      <ReorderWarningDialog
        open={showReorderWarning}
        onClose={() => setShowReorderWarning(false)}
        onConfirm={handleSave}
      />
    </>
  );
};
